import React from 'react';
import { createContext, useState } from 'react';

const PageEffect = {
    FadeOutNegativeGrid: "FadeOutNegativeGrid",
    FadeOutSessionGrid: "FadeOutSessionGrid"
}

export default PageEffect;